import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { COMPANY } from "@/data/site";

const lines = ["Klarheit.", "Präzision.", "Perfektion."];

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.18, delayChildren: 0.3 } },
};
const lineVariant = {
  hidden: { y: "110%" },
  show: { y: "0%", transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] } },
};

export default function Hero() {
  return (
    <section id="top" className="relative min-h-screen w-full overflow-hidden noise">
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.pexels.com/photos/10344210/pexels-photo-10344210.jpeg"
          alt="Moderne Glasfassade"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#030712]/70 via-[#030712]/60 to-[#030712]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_30%,rgba(0,229,255,0.12),transparent_55%)]" />
      </div>

      <div className="relative z-10 mx-auto flex min-h-screen max-w-7xl flex-col justify-center px-6 md:px-10 pt-24">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.15, duration: 0.8 }}
          className="font-mono text-xs uppercase tracking-[0.3em] text-cyan-glass mb-8"
          data-testid="hero-overline"
        >
          Glas- & Gebäudereinigung · {COMPANY.city}
        </motion.p>

        <motion.h1
          variants={container}
          initial="hidden"
          animate="show"
          className="font-heading text-6xl sm:text-7xl md:text-8xl lg:text-[8.5rem] font-semibold leading-[0.9] tracking-tighter text-white"
        >
          {lines.map((line, i) => (
            <span key={i} className="block overflow-hidden">
              <motion.span
                variants={lineVariant}
                className={`inline-block ${i === 2 ? "text-glow text-cyan-glass" : ""}`}
              >
                {line}
              </motion.span>
            </span>
          ))}
        </motion.h1>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.1, duration: 0.8 }}
          className="mt-10 flex flex-col sm:flex-row sm:items-center gap-6 max-w-2xl"
        >
          <p className="text-base md:text-lg font-light text-white/70 leading-relaxed">
            Ihr Partner in Sachen Sauberkeit — kompetent, kostengünstig und zuverlässig.
            {" "}<span className="text-white">{COMPANY.slogan}</span>
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.3, duration: 0.8 }}
          className="mt-10 flex flex-wrap items-center gap-4"
        >
          <a
            href="#kontakt"
            data-testid="hero-cta-primary"
            className="inline-flex items-center gap-2 rounded-full bg-cyan-glass px-8 py-4 font-mono text-xs uppercase tracking-[0.15em] text-[#030712] font-medium transition-transform duration-200 active:scale-95 hover:shadow-[0_0_40px_rgba(0,229,255,0.5)]"
          >
            Kostenloses Angebot
          </a>
          <a
            href="#leistungen"
            data-testid="hero-cta-secondary"
            className="inline-flex items-center gap-2 rounded-full border border-white/20 px-8 py-4 font-mono text-xs uppercase tracking-[0.15em] text-white transition-colors duration-200 hover:border-cyan-glass hover:text-cyan-glass"
          >
            Leistungen ansehen
          </a>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.6, duration: 1 }}
        className="absolute bottom-8 left-1/2 z-10 -translate-x-1/2 text-white/40"
      >
        <ArrowDown className="h-5 w-5 animate-bounce" strokeWidth={1.5} />
      </motion.div>
    </section>
  );
}
